module.exports = __webpack_public_path__ + "static/thomas-swimming-3b7b6fa8f97398a5e507c5dbb34bbaaa.jpg";